import React from 'react'
import { Table, Tag, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import moment from 'moment'
import { DETAILS_PAGE_SIZE, EMPTY_VALUE } from '../../const'
import { GatewayHistoryRecord } from '../../types'
import { useGatewayDetails } from './hooks'
import { detailsPageChanged } from './model'

const { Text } = Typography

type Props = {
  clientId: string
  gatewayId: number
}

export const GatewayHistoryDetails: React.FC<Props> = ({
  clientId,
  gatewayId,
}) => {
  const { items, total, page, loading } = useGatewayDetails(gatewayId)

  // Internal Name, Provider and Type are not repeated here — they are already
  // in the parent row.
  const columns: ColumnsType<GatewayHistoryRecord> = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 80,
    },
    {
      title: 'Status',
      dataIndex: 'isBlocked',
      width: 100,
      render: (isBlocked: boolean) =>
        isBlocked ? (
          <Tag color="red" style={{ fontSize: 10, fontWeight: 700 }}>
            Blocked
          </Tag>
        ) : (
          <Tag color="success" style={{ fontSize: 10, fontWeight: 700 }}>
            Active
          </Tag>
        ),
    },
    {
      title: 'Reason',
      dataIndex: 'reason',
      render: (reason: string | null) => reason || EMPTY_VALUE,
    },
    {
      title: 'Manager',
      dataIndex: 'manager',
      width: 180,
      render: (manager: string | null) => manager ?? EMPTY_VALUE,
    },
    {
      title: 'Was auto-blocked',
      dataIndex: 'isAuto',
      width: 140,
      render: (isAuto: boolean) => (isAuto ? 'Yes' : 'No'),
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      width: 160,
      render: (createdAt: string | null) =>
        createdAt ? (
          <>
            {moment.parseZone(createdAt).format('YYYY-MM-DD')}{' '}
            <Text type="secondary">
              {moment.parseZone(createdAt).format('HH:mm')}
            </Text>
          </>
        ) : (
          EMPTY_VALUE
        ),
    },
  ]

  return (
    <Table
      size="small"
      dataSource={items}
      loading={loading}
      rowKey="id"
      columns={columns}
      pagination={{
        current: page,
        pageSize: DETAILS_PAGE_SIZE,
        total,
        size: 'small',
        showSizeChanger: false,
        hideOnSinglePage: true,
        position: ['bottomCenter'],
      }}
      onChange={(pagination) =>
        detailsPageChanged({
          clientId,
          gatewayId,
          page: pagination.current ?? 1,
        })
      }
    />
  )
}
